/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Remote } from './Remote'
import { ReplicationStats } from './ReplicationStats'

export class ReplicatorDocument {
  constructor(json: JSON | any) {
    Object.assign(this as ReplicatorDocument, json)
  }

  id?: string
  rev?: string
  source?: Remote
  target?: Remote
  owner?: string
  createTarget?: boolean
  continuous?: boolean
  docIds?: Array<string>
  replicationState?: string
  replicationStateTime?: number
  replicationStats?: ReplicationStats
  errorCount?: number
  revsInfo?: Array<{ [key: string]: string }>
  revHistory?: { [key: string]: string }
}
